<article class="operational-status-card" [attr.data-status]="status">
    <div class="operational-status-card__row">
        <div class="operational-status-card__text">
            <h4 class="operational-status-card__title">{{ card.title }}</h4>
            <p *ngIf="card.detail" class="operational-status-card__detail">{{ card.detail }}</p>
        </div>
        <span class="operational-status-badge" [attr.data-status]="status">{{ statusLabel }}</span>
    </div>

    <div *ngIf="card.warnings?.length" class="operational-status-card__warnings">
        <app-operational-warning-card
                *ngFor="let warning of card.warnings"
                [warning]="warning">
        </app-operational-warning-card>
    </div>
</article>
